import { cn } from '../../lib/utils'

interface BadgeProps {
  children: React.ReactNode
  variant?: 'default' | 'success' | 'warning' | 'error'
  className?: string
}

const variantStyles = {
  default: 'bg-slate-700 text-slate-300',
  success: 'bg-green-500/20 text-green-400',
  warning: 'bg-doge-500/20 text-doge-400',
  error: 'bg-red-500/20 text-red-400',
}

export function Badge({ children, variant = 'default', className }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center px-2 py-1 rounded-md text-xs font-medium',
        variantStyles[variant],
        className
      )}
    >
      {children}
    </span>
  )
}
